import { render } from "./LatestNews.vue?vue&type=template&id=7260bb45&scoped=true"
import script from "./LatestNews.vue?vue&type=script&lang=js"
export * from "./LatestNews.vue?vue&type=script&lang=js"

import "./LatestNews.vue?vue&type=style&index=0&id=7260bb45&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\47959\\OneDrive\\Documents\\GitHub\\Poesiparken\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7260bb45"]])

export default __exports__